

























import Vue from 'vue'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection } from 'devextreme-vue/data-grid'
import { ProjectBookingStart } from '@/model/project/ProjectBookingStart'

interface ComponentData {

}

export default Vue.extend({
  name: 'BookingAssistant1',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSelection
  },

  props: {
    step1Data: Array as () => ProjectBookingStart[]
  },

  data (): ComponentData {
    return {

    }
  },

  watch: {
    step1Data (newVal: ProjectBookingStart[]): void {
      if(newVal && newVal[0]) {
        //@ts-ignore
        setTimeout(() => {this.$refs.dataGrid.instance.selectRows([newVal[0].SchrittID])}, 100)
      }
    }
  },

  computed: {

  },

  methods: {
    onSelectionChanged (data: any): void {
      if(data.selectedRowKeys.length > 1) {
        data.component.deselectRows([data.selectedRowKeys[0]])
      } else if(data.selectedRowKeys.length === 0) {
        if(this.step1Data && this.step1Data[0]) {
          data.component.selectRowsByIndexes(0)
        }
      } else {
        this.$emit("changeSelectedSchritt", data.selectedRowsData[0])
      }

    },

    onChangeCollectiveBooking (item: boolean): void {
      this.$emit("changeCollectiveBooking", item)
    }
  },

  mounted () {}
})
